module.exports = __webpack_public_path__ + "img/vorspeise.69e24052.jpg";